import React from 'react';
import { useToastStore } from '../store/useToastStore';

const TYPE_CLASS: Record<string, string> = {
  success: 'text-bg-success',
  danger: 'text-bg-danger',
  info: 'text-bg-primary',
};

export default function ToastContainer() {
  const { toasts, removeToast } = useToastStore();

  if (toasts.length === 0) return null;

  return (
    <div
      className="toast-container position-fixed bottom-0 end-0 p-3"
      style={{ zIndex: 1200 }}
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`toast show align-items-center border-0 mb-2 ${TYPE_CLASS[toast.type] ?? TYPE_CLASS.info}`}
          role="alert"
          aria-live="assertive"
        >
          <div className="d-flex">
            <div className="toast-body" style={{ fontSize: '0.875rem' }}>
              {toast.message}
            </div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              aria-label="Schließen"
              onClick={() => removeToast(toast.id)}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
